/* eslint-disable */
const eventEmitter = {};

eventEmitter.list = {};

// 订阅
eventEmitter.on = function (event, fn) {
  const _this = this;
  (_this.list[event] || (_this.list[event] = [])).push(fn);
  return _this;
};

eventEmitter.emit = function () {
  const _this = this;
  const event = [].shift.call(arguments);
  const fns = [..._this.list[event]];
  if (!fns || fns.length === 0) {
    return false;
  }

  fns.forEach((fn) => {
    fn.apply(_this, arguments);
  });

  return _this;
};

eventEmitter.off = function (event) {
  const _this = this;
  const fns = _this.list[event];
  if (!fns) return false;
  fns && (fns.length = 0);
  return _this;
};

export default eventEmitter;
